<script setup lang="ts">
import { ref } from "vue";

const frameKey = ref(0);

function refresh() {
  frameKey.value += 1;
}

function openStandalone() {
  window.open("/api/v1/sso/crmeb/launch", "_blank", "noopener,noreferrer");
}
</script>

<template>
  <section class="embedded-system-shell">
    <div class="embedded-system-toolbar">
      <div>
        <strong>小程序商城</strong>
        <span>商品、订单、会员与营销管理</span>
      </div>
      <div class="embedded-system-actions">
        <button type="button" @click="refresh">刷新连接</button>
        <button type="button" @click="openStandalone">独立窗口</button>
      </div>
    </div>
    <iframe
      :key="frameKey"
      src="/api/v1/sso/crmeb/launch"
      title="小程序商城"
      allow="clipboard-read; clipboard-write; notifications"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </section>
</template>

<style scoped>
.embedded-system-shell { min-height: 650px; height: calc(100vh - 96px); display: flex; flex-direction: column; overflow: hidden; background: #fff; border: 1px solid #e3e8f1; border-radius: 14px; box-shadow: 0 7px 24px rgba(20, 35, 68, .055); }
.embedded-system-toolbar { min-height: 56px; padding: 9px 14px; display: flex; align-items: center; justify-content: space-between; gap: 16px; border-bottom: 1px solid #e8ecf3; background: #fff; }
.embedded-system-toolbar strong, .embedded-system-toolbar span { display: block; }
.embedded-system-toolbar strong { color: #202c45; font-size: 14px; }
.embedded-system-toolbar span { margin-top: 3px; color: #8a95a8; font-size: 11px; }
.embedded-system-actions { display: flex; gap: 8px; }
.embedded-system-actions button { border: 0; border-radius: 8px; padding: 7px 11px; color: #315efb; background: #edf2ff; cursor: pointer; font-size: 11px; }
.embedded-system-shell iframe { width: 100%; flex: 1; border: 0; background: #f4f6fa; }
@media (max-width: 680px) {
  .embedded-system-toolbar { align-items: flex-start; flex-wrap: wrap; }
}
</style>
